import PropTypes from 'prop-types'
import styled from 'styled-components'
import colors from 'components/utils/colors'

const StyledWrapper = styled.div`
  display: flex;
  position: relative;
  top: 1px;
  font-size: 10px;
  color: ${colors.secondary60};
  align-items: baseline;
`

const BrandingLogo = styled.img`
  width: auto;
  margin-right: 8px;
`

const BrandingText = styled.div`
  white-space: nowrap;
  font-weight: 600;
`

const ComcastCopyrightRenderer = ({ className, icon, text }) => {
  const year = (new Date()).getFullYear()

  return (
    <StyledWrapper className={className}>
      {
        icon &&
          <BrandingLogo src={icon} />
      }
      <BrandingText>&copy; {year} {text}</BrandingText>
    </StyledWrapper>
  )
}

ComcastCopyrightRenderer.propTypes = {
  icon: PropTypes.string,
  text: PropTypes.string,
}

export default ComcastCopyrightRenderer
